import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { ModelUnion as Model } from '@app/models/core/base.model';

export class AcknowledgedAtColumn extends Column {
    title = 'payroll.setup.padAgreementLogs.acknowledgedAt';
    type = CellDisplay.string;
    property = 'acknowledgedAt';
    displayWidth = 35;

    constructor(private locale: string = 'en-CA') {
        super();
    }

    override getDisplayPropertyValue(object: Model): string {
        const raw = super.getDisplayPropertyValue(object) as string;
        if (!raw) return '-';
        return new Intl.DateTimeFormat(this.locale, {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZone: 'UTC',
            timeZoneName: 'short',
        }).format(new Date(raw));
    }
}
